module.exports = __webpack_public_path__ + "img/instagram.33df32de.svg";